import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import useDocumentTitle from "../../components/helpers/useDocumentTitle";
import PageHeader from "../../components/shared/PageHeader";
import PageMain from "../../containers/shared/PageMain";
import apiClient from "../../components/utils/apiClient";
import MainContent from "../../containers/shared/MainContent";
import NotificationBar from "../../components/NotificationsCenter/NotificationBar";
import NotificationTable from "../../components/NotificationsCenter/NotificationTable";
import Pagination from "../../components/shared/Pagination";
import Loading from "../../components/shared/Loading";

const NotificationsCenterPage = () => {
    const {t,i18n} = useTranslation();
    useDocumentTitle('مركز التنبيهات');
    const [userData, setUserData] = useState(null);
    const pageTitle = {title: 'مركز التنبيهات', subTitle: 'يمكنك متابعة التنبيهات المرسلة لك من المالك'};
    const [notifications, setNotifications] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const [pageSize, setPageSize] = useState(20);
    const [currentPage,setCurrentPage] = useState(1);
    const [total,setTotal] = useState(0);
    const [currentCount,setCurrentCount] = useState(0);
    const [hasMore,setHasMore] = useState(true);
    const [isEmpty, setIsEmpty] = useState(true);

    const [searchParams] = useSearchParams();
    const querySearch = searchParams.get('search') || "";

    useEffect(() => {
      if (querySearch.length > 0 && querySearch.length < 3) {
        return;
      }

      const delayDebounceFn = setTimeout(() => {
        getNotifications(1, querySearch);
      }, 500);

      return () => clearTimeout(delayDebounceFn);
    }, [querySearch]);

    const handleGetUser = (user) => {
        setUserData(user);
    }

    const getNotifications = async (page=1, searchTerm = "") => {

      let url = `/b-notifications/all-for-owner?skip=${(page-1)*pageSize}&limit=${pageSize}`;
      
      if (searchTerm && searchTerm.length >= 3) {
        url += `&search=${encodeURIComponent(searchTerm)}`;
      }
      try {
        const response = await apiClient.get(url);
        if(response?.data) {
            setIsLoading(false);
            setNotifications(response?.data);
            if(response?.data?.length > 0) {
                setIsEmpty(false);
                setCurrentCount(response?.data?.length);
                setCurrentPage(page);
                if(response?.data?.length === pageSize) {
                    setHasMore(true);
                }
            } else {
                setHasMore(false);
            }
        }
      } catch(err) {}
    }

    const handleChangePageAction = (page) => {
      getNotifications(page);
    }

    useEffect(()=>{
        getNotifications();
    },[]);


    return (
        <div>
            <PageHeader pageTitle={pageTitle} userCallback={handleGetUser} />
            <PageMain>
               <div className="fixed top-0 left-0 w-full h-full bg-grey-50 z-[-1]"></div>
                <MainContent>
                    <NotificationBar notificationCount={notifications?.length} />
                    {/* no notification view */}
                    {notifications !== null && Array.isArray(notifications) && notifications?.length < 1 && !querySearch && !isEmpty && <Loading showLoading={true} />}
                    {notifications !== null && Array.isArray(notifications) && notifications?.length < 1 && !querySearch && isEmpty &&
                        <div className="pt-[80px] text-center">
                        <div className="inline-block w-[188px] h-[188px] !bg-contain !bg-center" style={{background: "url('/assets/images/notification-status.svg')"}}></div>
                        <div className="w-full text-center text-grey-900 text-[24px] font-[500] mb-[25px]">لم تقم بإضافة أي تنبيه حتى الآن</div>
                        <Link className="inline-block min-w-[320px] h-[48px] leading-[48px] rounded-[8px] text-white bg-grey-800 text-[18px] font-[600]" to="/ar/notifications-center/add">أرسل تنبيه جديد</Link>
                        </div>
                    }
                    {notifications !== null && Array.isArray(notifications) && notifications?.length < 1 && querySearch &&
                        <div className="pt-[80px] text-center">
                        <div className="inline-block w-[188px] h-[188px] !bg-contain !bg-center" style={{background: "url('/assets/images/notification-status.svg')"}}></div>
                        <div className="w-full text-center text-grey-900 text-[24px] font-[500] mb-[25px]">لايوجد تنبيهات مطابقة لكلمة البحث</div>
                        {/* <Link className="inline-block min-w-[320px] h-[48px] leading-[48px] rounded-[8px] text-white bg-grey-800 text-[18px] font-[600]" to="/ar/users/add">أضف مستخدم جديد</Link> */}
                        </div>
                    }
                    {/* notification view */}
                    {notifications !== null && Array.isArray(notifications) && notifications?.length > 0 && 
                        <div className="pt-[25px]">
                            <NotificationTable notification={notifications} currentPage={currentPage} pageSize={pageSize} />
                            <Pagination label={'تنبيه'} currentCount={currentCount} currentPage={currentPage} pageSize={pageSize} handleClickChangePage={page => handleChangePageAction(page)} hasMore={hasMore} />
                        </div>
                    }
                </MainContent>
            </PageMain>

            {isLoading && <Loading showLoading={true} />}
        </div>
    )

}
export default NotificationsCenterPage;